import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { StyledTrack, StyledThumb } from './Scrollbar.style';
import { getViewProps } from './utils';

/* eslint-disable react/prop-types */
const Track = ({ style }) => <StyledTrack style={style} />;
const Thumb = ({ style }) => <StyledThumb style={style} />;
const ViewComponent = ({ defaultProps, givenProps }) => (
  <div {...getViewProps(defaultProps, givenProps)} className="scroll-view" />
);
const View = (givenProps) => (defaultProps) =>
  ViewComponent({ defaultProps, givenProps });

const Scrollbar = ({
  children,
  className,
  viewProps,
  scrollBarRef,
  ...scrollbarProps
}) => (
  <Scrollbars
    autoHide
    ref={scrollBarRef}
    className={className}
    renderTrackVertical={Track}
    renderThumbVertical={Thumb}
    renderView={View(viewProps)}
    {...scrollbarProps}
  >
    {children}
  </Scrollbars>
);

Scrollbar.propTypes = {
  className: PropTypes.string,
  thumbSize: PropTypes.number,
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  viewProps: PropTypes.object,
  scrollBarRef: PropTypes.func,
};

Scrollbar.defaultProps = {
  className: '',
  thumbSize: null,
  children: null,
  viewProps: {},
  scrollBarRef: () => {},
};

export default Scrollbar;
